// Cliente de base de datos sin SQLite. Solo Supabase; aquí devolvemos no-ops.

export async function getDb() {
  return null;
}

// Utilidades comunes: no realizan consultas reales; usar módulos Supabase.
export async function query(sql, params = []) {
  return [];
}

export async function execute(sql, params = []) {
  return { rowsAffected: 0, lastInsertId: null };
}